import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      form: {
        id: '',
        site: '',
        phone: '',
        language: '',
        email: ''
      },
      copyform: {},
      dialogShow: false,
      rules: {
        email: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        phone: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        site: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.copyform = _objectSpread({}, this.form);
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogShow = true;

                if (data) {
                  _this.form = _objectSpread({}, data);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = _objectSpread(_objectSpread({}, this.copyform), {}, {
        id: type ? this.form.id : ""
      });
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.form));
          var reqFn = data.id ? 'contactWayUpdate' : 'contactWayAdd';

          _this2.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};